<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            min="0"
            :error="errors.redoxFort.length > 0"
            :error-messages="errors.redoxFort"
            v-model="form.redoxFort"
            :placeholder="$t('dashboard_new_evollu.measurement_types.redox_fort_short')+' (FORT)'"
            :label="$t('dashboard_new_evollu.measurement_types.redox_fort_short')+' (FORT)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.redoxFord.length > 0"
          :error-messages="errors.redoxFord"
          v-model="form.redoxFord"
          :placeholder="$t('dashboard_new_evollu.measurement_types.redox_ford_short')+ ' (mmol/L)'"
          :label="$t('dashboard_new_evollu.measurement_types.redox_ford_short')+ ' (mmol/L)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.redoxUricAcid.length > 0"
          :error-messages="errors.redoxUricAcid"
          v-model="form.redoxUricAcid"
          :placeholder="$t('dashboard_new_evollu.measurement_types.redox_uric_acid_short')+' (mg/dL)'"
          :label="$t('dashboard_new_evollu.measurement_types.redox_uric_acid_short')+' (mg/dL)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.redoxIndex.length > 0"
          :error-messages="errors.redoxIndex"
          v-model="form.redoxIndex"
          :placeholder="$t('dashboard_new_evollu.measurement_types.redox_index_short')"
          :label="$t('dashboard_new_evollu.measurement_types.redox_index_short')"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

  </div>
</template>

<script>
import moment from "moment";
const REDOX_FORT_TYPE_ID = 111
const REDOX_FORD_TYPE_ID = 112
const REDOX_URIC_ACID_TYPE_ID = 113
const REDOX_INDEX_TYPE_ID = 118

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        redoxFort: null,
        redoxFord: null,
        redoxUricAcid: null,
        redoxIndex: null,
      },
      errors: {
        redoxFort: [],
        redoxFord: [],
        redoxUricAcid: [],
        redoxIndex: [],
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 27
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.redoxFort !== null && this.form.redoxFort !== '') ||
        (this.form.redoxFord !== null && this.form.redoxFord !== '') ||
        (this.form.redoxUricAcid !== null && this.form.redoxUricAcid !== '') ||
        (this.form.redoxIndex !== null && this.form.redoxIndex !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.redoxFort": function(value) {
        if(value !== '' && (value <= 0)) {
          this.errors.redoxFort = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
        }
        else {
          this.errors.redoxFort = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === REDOX_FORT_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === REDOX_FORT_TYPE_ID)
          elem.value = this.errors.redoxFort.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.redoxFort.length === 0 ? value : null,
            typeId: REDOX_FORT_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.redoxFord": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.redoxFord = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.redoxFord = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === REDOX_FORD_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === REDOX_FORD_TYPE_ID)
        elem.value = this.errors.redoxFord.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.redoxFord.length === 0 ? value : null,
          typeId: REDOX_FORD_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.redoxUricAcid": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.redoxUricAcid = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.redoxUricAcid = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === REDOX_URIC_ACID_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === REDOX_URIC_ACID_TYPE_ID)
        elem.value = this.errors.redoxUricAcid.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.redoxUricAcid.length === 0 ? value : null,
          typeId: REDOX_URIC_ACID_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.redoxIndex": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.redoxIndex = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.redoxIndex = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === REDOX_INDEX_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === REDOX_INDEX_TYPE_ID)
        elem.value = this.errors.redoxIndex.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.redoxIndex.length === 0 ? value : null,
          typeId: REDOX_INDEX_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
